module.exports = __webpack_public_path__ + "img/scene_5.b48b9a26.jpg";